<template>
  <v-container class="pb-0">
    <v-row>
      <v-col md="4" sm="12">
        <v-text-field
          v-model="filters.title"
          :label="$t('common.title')"
          solo
          dense
        ></v-text-field>
      </v-col>
      <v-col md="2" sm="12">
        <v-select
          v-model="filters.type"
          :items="types"
          :label="$t('tasks.selectType')"
          solo
          dense
        ></v-select>
      </v-col>
      <v-col md="2" sm="12">
        <v-select
          v-model="filters.status"
          :items="statuses"
          :label="$t('common.selectStatus')"
          solo
          dense
        ></v-select>
      </v-col>
      <v-col md="2" xs="6">
        <v-btn color="default" block @click="reset()">
          {{ $t('common.reset') }}
        </v-btn>
      </v-col>
      <v-col md="2" xs="6">
        <v-btn color="primary" block @click="filter()">
          {{ $t('common.filter') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import taskTypes from '../../../enums/task.types';
import approvalStatuses from '../../../enums/approval.statuses';
import listFilterMixin from '../../shared/mixins/list.filter.mixin';

export default {
  name: 'tasks-list-filter',
  mixins: [listFilterMixin],
  data() {
    return {
      defaultFilters: {
        title: null,
        type: null,
        status: null
      },
      types: [
        {
          text: this.$i18n.t('tasks.selectType'),
          value: ''
        },
        ...Object.values(taskTypes).map(type => ({
          text: this.$i18n.t(`tasks.taskTypes.${type}`),
          value: type
        }))
      ],
      statuses: [
        {
          text: this.$i18n.t('common.selectStatus'),
          value: ''
        },
        ...Object.values(approvalStatuses).map(status => ({
          text: this.$i18n.t(`common.approvalStatuses.${status}`),
          value: status
        }))
      ]
    };
  }
};
</script>
